/**
 * 示波器中每个echart可容纳的最大节点数量
 * @type {number}
 */
const OSCILLOGRAM_CHART_MAX_NODE_NUM = 5000;

export default {
  OSCILLOGRAM_CHART_MAX_NODE_NUM,
};



// WEBPACK FOOTER //
// ./src/common/Constants.js